import env from '../env.json';

const getEnvVariable = key => (
  env[process.env.SIGNUP_ENV][key] ? env[process.env.SIGNUP_ENV][key] : null
);

export default getEnvVariable;
